import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import ListIcon from "@mui/icons-material/List";

function List() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const goToCatalog = (e) => {
    e.currentTarget.blur();
    window.open("https://www.mempro.co.kr/about/e-catalog", "_blank");
  };
  return (
    <Tooltip title="List">
      <IconButton
        aria-label="list"
        color="primary"
        onClick={(e) => goToCatalog(e)}
      >
        <ListIcon />
      </IconButton>
      {/* <button>List</button> */}
    </Tooltip>
  );
}

export default List;
